import React, { useState } from 'react'
import styled from 'styled-components';

export const TestView = () => {
    const [show, setShow] = useState(false);
    const toggleVisibility = () => {
        setShow((prevShow) => !prevShow);
      };
  return (
    <Root>

    <h1 onClick={toggleVisibility}>Click Here</h1>

    {show && (
        <>
          <h2>Show Here</h2>
          <h2>Show Here</h2>
        </>
      )}


      
    </Root>
  )
}


const Root = styled.section`



`;


